export const INITIAL_STATE = {
    comments: {},
    createCommenIsLoading: false,
    createCommenErrors: null,
    deleteCommentIsLoading: false,
    deleteCommentErrors: null,
    getArticleCommentsIsLoading: false,
    getArticleCommentsErrors: null,
}